import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'secondsToTimeFormat'
})
export class SecondsToTimeFormatPipe implements PipeTransform {
    transform(value: number, includeMs: boolean = true): string {
        if (value === null || value === undefined) return includeMs ? '00:00:00.0' : '00:00:00';

        let hours = Math.floor(value / 3600);
        let minutes = Math.floor((value - (hours * 3600)) / 60);
        let seconds = value - (hours * 3600) - (minutes * 60);
        let milliseconds = Math.floor((seconds - Math.floor(seconds)) * 10);
        seconds = Math.floor(seconds);

        let result = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;

        if (includeMs) {
            result += `.${milliseconds}`;
        }

        return result;
    }

    private pad(num: number): string {
        return num < 10 ? '0' + num : num.toString();
    }
}
